// src/extenders/sticky-menu-hover.js
var StickyMenuHover = class extends HTMLElement {
  constructor() {
    super();
    this.menuButtons = [];
    this.enterHandlers = /* @__PURE__ */ new Map();
    this.leaveHandlers = /* @__PURE__ */ new Map();
    this.keepHoverActive = true;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.cleanup();
  }
  init() {
    this.keepHoverActive = this.dataset.keepHoverActive === "true";
    this.menuButtons = document.querySelectorAll(".primary__desktop-menu-button, .navigation__link");
    this.menuButtons.forEach((button) => {
      const enterHandler = () => this.activateButton(button);
      this.enterHandlers.set(button, enterHandler);
      button.addEventListener("mouseenter", enterHandler);
      if (!this.keepHoverActive) {
        const leaveHandler = () => this.deactivateButton(button);
        this.leaveHandlers.set(button, leaveHandler);
        button.addEventListener("mouseleave", leaveHandler);
      }
    });
  }
  cleanup() {
    this.menuButtons.forEach((button) => {
      const enterHandler = this.enterHandlers.get(button);
      if (enterHandler) {
        button.removeEventListener("mouseenter", enterHandler);
      }
      const leaveHandler = this.leaveHandlers.get(button);
      if (leaveHandler) {
        button.removeEventListener("mouseleave", leaveHandler);
      }
    });
    this.enterHandlers.clear();
    this.leaveHandlers.clear();
    this.menuButtons = [];
  }
  activateButton(button) {
    const allButtons = document.querySelectorAll(".primary__desktop-menu-button, .navigation__link");
    allButtons.forEach((btn) => {
      const isDropdownButton2 = btn.classList.contains("primary__desktop-menu-button");
      const activeClass2 = isDropdownButton2 ? "primary__desktop-menu-button--active" : "navigation__link--active";
      if (!btn.hasAttribute("data-permanent-active")) {
        btn.classList.remove(activeClass2);
      }
    });
    const isDropdownButton = button.classList.contains("primary__desktop-menu-button");
    const activeClass = isDropdownButton ? "primary__desktop-menu-button--active" : "navigation__link--active";
    button.classList.add(activeClass);
  }
  deactivateButton(button) {
    if (!button.hasAttribute("data-permanent-active")) {
      const isDropdownButton = button.classList.contains("primary__desktop-menu-button");
      const activeClass = isDropdownButton ? "primary__desktop-menu-button--active" : "navigation__link--active";
      button.classList.remove(activeClass);
    }
  }
};
if (customElements.get("sticky-menu-hover") === void 0) {
  customElements.define("sticky-menu-hover", StickyMenuHover);
}
